import { Box, Container, Typography, keyframes } from "@mui/material";

// Keyframes for dot animation
const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  } 
  40% {
    transform: scale(1);
  }
`;

const Dot = ({ delay }) => (
  <Box
    sx={{
      width: 8,
      height: 8,
      backgroundColor: "error.main",
      borderRadius: "50%",
      display: "inline-block",
      animation: `${bounce} 1.4s infinite`,
      animationDelay: delay,

    }}
  />
);

const Loading = () => {
    // document.title = "Loading...";

  return (
    <Container maxWidth="lg">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="80vh"
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          gap={2}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="body2" color="textSecondary">
              Loading
            </Typography>
            <Box display="flex" gap={0.5} ml={1}>
              <Dot delay="0s" />
              <Dot delay="0.2s" />
              <Dot delay="0.4s" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Loading;
